import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  makeGetEventName,
  makeGetEventSelectionsByMarketName,
  makeGetEventStartTime
} from '../../../modules/events/selectors';
import SelectionButton from '../SelectionButton';

export const EventTile = ({ eventName, eventStartTime, selectionIds }) => (
  selectionIds ? (
    <div className="bb-event-tile">
      <div className="bb-event-tile__event-info bb-event-info">
        <span className="bb-event-info__event-name">
          {eventName}
        </span>
        <span className="bb-event-info__event-start">
          {eventStartTime}
        </span>
      </div>
      <div className="bb-event-tile__selections">
        {selectionIds.map(selectionId => (
          <SelectionButton key={selectionId} selectionId={selectionId} />
        ))}
      </div>
    </div>
  ) : null
);

EventTile.propTypes = {
  eventName: PropTypes.string.isRequired,
  eventStartTime: PropTypes.string.isRequired,
  selectionIds: PropTypes.object
};

const makeMapStateToProps = (initialState, initialProps) => {
  const getEventName = makeGetEventName();
  const getEventStartTime = makeGetEventStartTime();
  const getEventSelectionsByMarketName = makeGetEventSelectionsByMarketName();
  return (state) => ({
    eventName: getEventName(state, initialProps),
    eventStartTime: getEventStartTime(state, initialProps),
    selectionIds: getEventSelectionsByMarketName(state, initialProps)
  });
};

export default connect(makeMapStateToProps)(EventTile);
